// extracted by mini-css-extract-plugin
export default {"input":"a--z","button":"b--z","selected":"c--z","unavailable":"d--z","oos":"e--z","image":"f--z","paperCutDisabledOverlay":"g--z"};